import parse from 'html-react-parser';
import { Box } from '@mui/material';
import { looksLikeHtml } from '../../utils/richText';
import '../../css/richText/richText.css';

/**
 * Renders a description as structured HTML (headings, lists, emphasis, colors)
 * or as preformatted plain text for rows written before the editor.
 */
const RichTextDisplay = ({ html, className = '' }) => {
    if (!html) {
        return null;
    }

    if (!looksLikeHtml(html)) {
        return (
            <Box className={`article_item_description richText_display richText_display--plain ${className}`.trim()}>
                {html}
            </Box>
        );
    }

    return (
        <Box className={`article_item_description richText_display ${className}`.trim()}>
            {parse(html)}
        </Box>
    );
};

export default RichTextDisplay;
